/*
 * ADA sitewide a11y enhancements (DEV-15145)
 * - Cart drawer live-region announcements (AC1 add: product + count, AC2 qty: subtotal)
 * - PDP purchase-option price announcement (AC6), without moving focus
 * Announces only existing, already-localized values/messages. No new copy.
 */
(() => {
  const getEurus = () => window.Eurus || {};
  const getCartStore = () =>
    window.Alpine && typeof Alpine.store === 'function' ? Alpine.store('xMiniCart') : null;

  const readCartCount = () => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return null;
    const value = bubble.getAttribute('data-value');
    if (value !== null && value.trim() !== '') return value.trim();
    const span = bubble.querySelector('span');
    return span ? span.textContent.trim() : null;
  };

  const readSubtotal = () => {
    const total = document.getElementById('total-price');
    return total ? total.textContent.trim() : null;
  };

  const readAddedTitles = () => {
    try {
      const noti = Alpine.store('xCartNoti');
      if (noti && noti.show && noti.listItem) {
        return Object.values(noti.listItem)
          .map((item) => item && item.title)
          .filter(Boolean);
      }
    } catch (error) {
      /* xCartNoti not available on this page */
    }
    return [];
  };

  const announceCart = () => {
    const store = getCartStore();
    if (!store) return;
    const eurus = getEurus();
    const parts = [];

    const titles = readAddedTitles();
    if (titles.length && eurus.cart_a11y_added) {
      parts.push(`${eurus.cart_a11y_added} ${titles.join(', ')}`);
    }

    const count = readCartCount();
    if (count && eurus.cart_a11y_in_cart) {
      parts.push(eurus.cart_a11y_in_cart.replace('[quantity]', count));
    }

    const subtotal = readSubtotal();
    if (subtotal && eurus.cart_a11y_total) {
      parts.push(`${eurus.cart_a11y_total} ${subtotal}`);
    }

    if (parts.length) store.announcement = `${parts.join('. ')}.`;
  };

  // The drawer re-renders asynchronously (AJAX). Watch it settle, then announce.
  let observer = null;
  let settleTimer = null;
  let armUntil = 0;

  const stopObserving = () => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  };

  const scheduleAnnounce = () => {
    clearTimeout(settleTimer);
    settleTimer = setTimeout(() => {
      announceCart();
      stopObserving();
    }, 300);
  };

  const onCartChanged = () => {
    armUntil = Date.now() + 2500;
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(announceCart, 500);
      return;
    }
    if (!observer) {
      observer = new MutationObserver(() => {
        if (Date.now() > armUntil) {
          stopObserving();
          return;
        }
        scheduleAnnounce();
      });
      observer.observe(drawer, { childList: true, subtree: true, characterData: true });
    }
    // Fallback in case no mutation fires.
    clearTimeout(settleTimer);
    settleTimer = setTimeout(announceCart, 900);
  };

  document.addEventListener('eurus:cart:items-changed', onCartChanged);

  // AC6 - announce the active purchase-option price on selection, without moving focus.
  const announcePrice = () => {
    const region = document.getElementById('a11y-price-status');
    if (!region) return;
    const active = document.querySelector('.product-bundle-select li.active .option-price');
    if (!active) return;
    const text = active.textContent.replace(/\s+/g, ' ').trim();
    if (text) region.textContent = text;
  };

  document.addEventListener('click', (event) => {
    const option = event.target.closest && event.target.closest('.product-bundle-select li');
    if (option) setTimeout(announcePrice, 50);
  });
})();
